import React, { Component } from 'react'
import _find from "lodash/find";

import {
    Grid,
    GridCell,
    DataCell,
    DataTable,
    DataBody,
    DataHeader,
    DataRow,
    Spinner,
    Icon,
    css,
    Toggler,
    Checkbox,
    Select,
    TextInput,
    Theme,
} from "@bdfx/mergado-ui-kit"

import {
    superadminGetProductsPerProject,
    superadminGetProjectsHistory,
    superadminToggleProjectLarge, superadminToggleProjectSkip
} from "app/helpers/api";

import toastFactory from "app/helpers/toast_factory";
import { createToast } from "actions";

import { GENERAL_ERROR, GENERAL_SUCCESS } from "template-edit/reducers";
import store from "store";
import { intboolean } from "app/types/app-types";
import { AxiosResponse } from "axios";
import { Option } from "@bdfx/mergado-ui-kit/lib/components/Form/Select";
import DoubleScrollBar from 'app/components/double-scroll-bar';
import { ALL_OUTPUT_FORMATS_WITHOUT_GIF } from 'shape-edit/forms/helpers';
import { Project } from 'app/types/model-types';

interface Props {
    selectedProjectId: number
    selectedTemplateId: number
}

export type ProjectHistoryDateTime = {
    activeFrom: string
    activeTo: string
    activeDiff: string
}

export type ProjectHistory = {
    projectId: number
    name: string
    user: string
    dateTimes: ProjectHistoryDateTime[]
}

export type ProductsPerProjectType = {
    project_id: number
    name: string
    output_image_format: string
    total_products: number
    is_large: intboolean
    is_skip: intboolean
} & Project

type ProjectsHistoryType = {
    projects_history: ProjectHistory[]
    history_since: string
}

interface State {
    productsPerProject: ProductsPerProjectType[]
    projectsHistory: ProjectsHistoryType
    isLoading: boolean
    filterIsSkip: boolean
    filterIsLarge: boolean
    filterFormat: string
    filterName: string
}


class ProjectsOverview extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            isLoading: false,
            productsPerProject: null,
            projectsHistory: null,
            filterIsSkip: null,
            filterIsLarge: null,
            filterFormat: null,
            filterName: null,
        }
    }

    updateData = () => {
        superadminGetProductsPerProject()
            .then((response: AxiosResponse<ProductsPerProjectType[]>) => {
                this.setState({ productsPerProject: response.data })
            })
            .catch(e => {
                store.dispatch(createToast(toastFactory(GENERAL_ERROR, e)))
            })
    }

    componentDidMount() {
        superadminGetProjectsHistory()
            .then((response: AxiosResponse<ProjectsHistoryType>) => {
                this.setState({ projectsHistory: response.data })
            })
            .catch(e => {
                store.dispatch(createToast(toastFactory(GENERAL_ERROR, e)))
            })

        this.updateData()
    }

    handleToggleIsLarge = (projectId: number) => {
        superadminToggleProjectLarge(projectId)
            .then((response: any) => {
                store.dispatch(createToast(toastFactory(GENERAL_SUCCESS)))
            })
            .catch(e => {
                store.dispatch(createToast(toastFactory(GENERAL_ERROR, e)))
            })
            .finally(() => {
                this.updateData()
            })
    }

    handleToggleSkip = (projectId: number) => {
        superadminToggleProjectSkip(projectId)
            .then((response: any) => {
                store.dispatch(createToast(toastFactory(GENERAL_SUCCESS)))
            })
            .catch(e => {
                store.dispatch(createToast(toastFactory(GENERAL_ERROR, e)))
            })
            .finally(() => {
                this.updateData()
            })
    }

    render() {
        const { isLoading, productsPerProject, projectsHistory, filterIsSkip, filterIsLarge, filterFormat, filterName } = this.state

        if (isLoading || !productsPerProject) {
            return <div>
                <Spinner type={'bubbles'} />
            </div>
        }

        const productsPerProjectFiltered = productsPerProject.filter((item: ProductsPerProjectType) => (
            (!filterIsLarge || filterIsLarge && item.is_large) &&
            (!filterIsSkip || filterIsSkip && item.is_skip) &&
            (!filterName || filterName && item.name && item.name.toLowerCase().includes(filterName.toLowerCase())) &&
            (!filterFormat || filterFormat && item.output_image_format === filterFormat)
        ))

        const filterFormatOptions: Option[] = [...ALL_OUTPUT_FORMATS_WITHOUT_GIF, 'gif'].map((o) => ({ label: o, value: o }))

        return (
            <StyledGrid>

                <GridCell col={'1/-1'}>
                    <Grid cols="repeat(auto-fit, minmax(100px, 1fr))" gap={"5px"} style={{ ' .muk-form-group': { marginBottom: 0, alignSelf: 'center' } }}>
                        <Checkbox label={'is skip'} value={filterIsSkip} onChange={(e) => this.setState({ filterIsSkip: e })} />
                        <Checkbox label={'is large'} value={filterIsLarge} onChange={(e) => this.setState({ filterIsLarge: e })} />
                        <Select
                            options={filterFormatOptions}
                            value={`${filterFormat}`}
                            onChange={(value) => this.setState({ filterFormat: value })}
                            onClear={() => this.setState({ filterFormat: null })}
                        />
                        <TextInput
                            value={filterName || ''}
                            placeholder={'project name'}
                            onChange={(value) => this.setState({ filterName: value })}
                            onClear={() => this.setState({ filterName: null })}
                        />
                    </Grid>
                </GridCell>

                <GridCell col={'span 2'}>
                    <b>Products per project</b>

                    <StyledDiv>
                        <DoubleScrollBar color={Theme.blue}>
                            <DataTable style={{ marginTop: '20px' }} onRowSelected={() => { }}>
                                <DataHeader>
                                    <DataCell type={"header"}>project_id</DataCell>
                                    <DataCell type={"header"}>project name</DataCell>
                                    <DataCell type={"header"}>image format</DataCell>
                                    <DataCell type={"header"}>total products</DataCell>
                                    <DataCell type={"header"}>is large?</DataCell>
                                    <DataCell type={"header"}>is skip?</DataCell>
                                    <DataCell type={"header"}>input image</DataCell>
                                    <DataCell type={"header"}>output image</DataCell>
                                    <DataCell type={"header"}>input alt image</DataCell>
                                    <DataCell type={"header"}>output alt image</DataCell>
                                    <DataCell type={"header"}>name</DataCell>
                                    <DataCell type={"header"}>item_id</DataCell>
                                    <DataCell type={"header"}>price_vat</DataCell>
                                    <DataCell type={"header"}>ean</DataCell>
                                    <DataCell type={"header"}>productno</DataCell>
                                    <DataCell type={"header"}>input format</DataCell>
                                    <DataCell type={"header"}>output format</DataCell>
                                </DataHeader>
                                <DataBody>
                                    {productsPerProjectFiltered &&
                                        productsPerProjectFiltered.map(productsPerProject => {
                                            return <DataRow dataId={'info'} key={`${productsPerProject.project_id}-${productsPerProject.is_large}`}>
                                                <DataCell>{productsPerProject.project_id}</DataCell>
                                                <DataCell>{productsPerProject.name}</DataCell>
                                                <DataCell>{productsPerProject.output_image_format}</DataCell>
                                                <DataCell>{productsPerProject.total_products}</DataCell>
                                                <DataCell>
                                                    <Toggler
                                                        value={productsPerProject.is_large}
                                                        onLabel={"On"}
                                                        offLabel="Off"
                                                        onChange={(value) => {
                                                            this.handleToggleIsLarge(productsPerProject.project_id)
                                                        }}
                                                    />
                                                </DataCell>
                                                <DataCell>
                                                    <Toggler
                                                        value={productsPerProject.is_skip}
                                                        onLabel={"On"}
                                                        offLabel="Off"
                                                        onChange={(value) => {
                                                            this.handleToggleSkip(productsPerProject.project_id)
                                                        }}
                                                    />
                                                </DataCell>
                                                <DataCell>{productsPerProject.e_img_url_input}</DataCell>
                                                <DataCell>{productsPerProject.e_img_url}</DataCell>
                                                <DataCell>{productsPerProject.e_alt_img_url_input}</DataCell>
                                                <DataCell>{productsPerProject.e_alt_img_url}</DataCell>
                                                <DataCell>{productsPerProject.e_name}</DataCell>
                                                <DataCell>{productsPerProject.e_item_id}</DataCell>
                                                <DataCell>{productsPerProject.e_price_vat}</DataCell>
                                                <DataCell>{productsPerProject.e_ean}</DataCell>
                                                <DataCell>{productsPerProject.e_productno}</DataCell>
                                                <DataCell>{productsPerProject.input_format}</DataCell>
                                                <DataCell>{productsPerProject.output_format}</DataCell>
                                            </DataRow>
                                        })
                                    }
                                </DataBody>
                            </DataTable>
                        </DoubleScrollBar>
                    </StyledDiv>
                </GridCell>

                <GridCell>
                    {projectsHistory && projectsHistory.history_since &&
                        <b>Projects history (since {projectsHistory.history_since})</b>
                    }

                    {projectsHistory && projectsHistory.history_since &&
                        <StyledDiv>
                            <DataTable style={{ marginTop: '20px' }} onRowSelected={() => { }}>
                                <DataHeader>
                                    <DataCell type={"header"}>project_id</DataCell>
                                    <DataCell type={"header"}>project name</DataCell>
                                    <DataCell type={"header"}>user</DataCell>
                                    <DataCell type={"header"}>history</DataCell>
                                </DataHeader>
                                <DataBody>
                                    {projectsHistory.projects_history &&
                                        projectsHistory.projects_history.map(projectHistory => {
                                            return <DataRow dataId={'info'} key={projectHistory.projectId}>
                                                <DataCell>{projectHistory.projectId}</DataCell>
                                                <DataCell>{projectHistory.name}</DataCell>
                                                <DataCell>{projectHistory.user}</DataCell>
                                                <DataCell>
                                                    {projectHistory.dateTimes &&
                                                        <ul>
                                                            {projectHistory.dateTimes.map((dateTime, key) => {
                                                                return <li key={`${projectHistory.projectId}-${key}`}>
                                                                    {dateTime.activeFrom || ''} - {dateTime.activeTo || ''}  {dateTime.activeDiff && <b>({dateTime.activeDiff})</b>}
                                                                </li>
                                                            })
                                                            }
                                                        </ul>
                                                    }
                                                </DataCell>
                                            </DataRow>
                                        })
                                    }
                                </DataBody>
                            </DataTable>
                        </StyledDiv>
                    }
                </GridCell>

            </StyledGrid>
        )
    }
}

const StyledDiv = css('div')({
    maxHeight: 'calc(100vh - 300px)',
    overflow: 'auto',
    ' .m-table': {
        margin: 0,
    }
})

const StyledGrid = css(Grid)({
    gridTemplateColumns: '1fr 1fr 1fr',
    gridGap: '10px',
    fontSize: 'small',
    '@media screen and (max-width: 1024px)': {
        gridTemplateColumns: 'auto',
    },
})

export default ProjectsOverview